import { Layers, Shuffle, Wallet, ShieldCheck } from "lucide-react";

const ITEMS = [
  { Icon: Layers, title: "Variedade de composição", text: "Cartas com diferentes valores de crédito, entrada e parcelas para você comparar." },
  { Icon: Shuffle, title: "Flexibilidade de uso", text: "O crédito pode ser usado na compra do bem dentro das regras da administradora." },
  { Icon: Wallet, title: "Poder de compra à vista", text: "Com a carta já contemplada, você negocia o bem como comprador à vista." },
  { Icon: ShieldCheck, title: "Segurança na negociação", text: "Acompanhamento em cada etapa e transferência feita junto à administradora." },
];

export const Benefits = () => (
  <section className="bg-white py-24 sm:py-32" data-testid="benefits-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#218FFF]">Benefícios</p>
      <h2 className="mt-3 max-w-3xl text-3xl font-extrabold uppercase tracking-tight text-[#15579A] sm:text-4xl">
        Transformamos espera em movimento.
      </h2>
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((b, i) => (
          <div key={b.title} data-testid={`benefit-card-${i}`}
            className="rounded-[24px] border border-[#C8D7E4] bg-[#F7F5F0] p-7 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[#218FFF]">
            <b.Icon className="h-9 w-9 text-[#218FFF]" strokeWidth={2.5} />
            <h3 className="mt-8 text-lg font-bold text-[#15579A]">{b.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#15579A]/75">{b.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
